module.exports = __webpack_public_path__ + "assets/img/box5_cimg3.7594a193.png";